import api from './api';
import { 
  TimelineResponse, 
  TimelineStatsResponse, 
  TimelineFilters 
} from '../types/Timeline';

export const timelineApi = {
  // Get all timeline events with pagination and filters
  getTimelineEvents: async (filters: TimelineFilters = {}): Promise<TimelineResponse> => {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.leadId) params.append('leadId', filters.leadId);
    if (filters.module) params.append('module', filters.module);
    if (filters.action) params.append('action', filters.action);
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.entityId) params.append('entityId', filters.entityId);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const response = await api.get(`/timeline?${params}`);
    return response.data;
  },

  // Get timeline events for a specific lead
  getTimelineEventsByLead: async (leadId: number, filters: TimelineFilters = {}): Promise<TimelineResponse> => {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.module) params.append('module', filters.module);
    if (filters.action) params.append('action', filters.action);
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const response = await api.get(`/timeline/lead/${leadId}?${params}`);
    return response.data;
  },

  // Get timeline events by module
  getTimelineEventsByModule: async (module: string, filters: TimelineFilters = {}): Promise<TimelineResponse> => {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.leadId) params.append('leadId', filters.leadId);
    if (filters.action) params.append('action', filters.action);

    const response = await api.get(`/timeline/module/${module}?${params}`);
    return response.data;
  },

  // Get timeline statistics
  getTimelineStats: async (): Promise<TimelineStatsResponse> => {
    const response = await api.get('/timeline/stats');
    return response.data;
  },

  // Delete timeline event
  deleteTimelineEvent: async (eventId: number): Promise<{ success: boolean; message?: string; data?: any }> => {
    const response = await api.delete(`/timeline/${eventId}`);
    return response.data;
  },

  // Bulk delete timeline events
  bulkDeleteTimelineEvents: async (eventIds: number[]): Promise<{ success: boolean; message?: string; data?: any }> => {
    const response = await api.delete('/timeline/bulk', {
      data: { eventIds }
    });
    return response.data;
  },

  // Delete timeline events by filters
  deleteTimelineEventsByFilters: async (filters: {
    module?: string;
    action?: string;
    leadId?: number;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<{ success: boolean; message?: string; data?: any }> => {
    const response = await api.delete('/timeline/bulk', {
      data: { filters }
    });
    return response.data;
  },
};
